import React, { useState } from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';
// import Logo from '@/Shared/Logo';
import { Col, Row, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCopyright} from '@fortawesome/free-regular-svg-icons'
import { APP_NAME } from '@/constants/Site';
// import MainSocialMenu from '@/Shared/Layouts/Menus/MainSocialMenu';

export default () => {
    return <Container>
        <Row className="justify-content-center">
            <Col sm="auto d-flex align-items-center"><span><FontAwesomeIcon icon={faCopyright} /> {APP_NAME} 2020. Todos los derechos reservados. Desarrollado por <a href="https://www.57sac.com/" target="_blank" className="link">57SAC</a> | <a href="https://github.com/GeinerGV" target="_blank" className="link" rel="noopener noreferrer">GeinerGV</a></span></Col>
            {/* <Col sm="auto align-items-center"><MainSocialMenu /></Col> */}
        </Row>
    </Container>
}